<capra-toast class="toast" type="warning" [inline]="true" [showCloseBtn]="true" (dismissToast)="dismissToast()">
  <div class="content">
    <h4 class="message">An error occured while uploading your Dataset.</h4>
    <capra-button-link
      text="See what's wrong"
      [href]="editDatasetLink"
      variant="secondary"
      color="neutral"
    ></capra-button-link>
  </div>
</capra-toast>
